import { z } from "zod";
export const contactRequestSchema = z.object({
    firstName: z.string().trim().min(1).max(200),
    lastName: z.string().trim().min(1).max(200),
    email: z.string().trim().email(),
    message: z.string().trim().min(1).max(5000),
    // Honeypot -- real users never see or fill this field, so a non-empty
    // value is a signal to silently drop the submission instead of emailing it.
    company: z.string().max(200).optional(),
});
